<template lang="pug">
    .game-wrapper
        ChangeTariffModal(
            v-if="showTariffModal"
            :tariff='profile'
            @close="closeTariffModal"
            )
        .game-preview
            .game-title
                .game-title__name(
                    :class="{'green':!isSuperAdmin && !showChangeTariffButton && !profile.isCoursesChangeAvailable }"
                ) {{ $i18n.t(`billing.billing_tariff_${profile.name}`) }}
                    svg-icon.title_check(
                        v-if="!isSuperAdmin && !showChangeTariffButton && !profile.isCoursesChangeAvailable"
                        :style="{marginLeft: '5px'}"
                        name="check",
                        size="large"
                        )
            .game-content
                .game__label {{ $i18n.t('billing.billing_subscriptions_amountOfTeachers') + ': ' + profile.restriction.teachersLimit}}
                .game__label {{ $i18n.t('billing.billing_subscriptions_amountOfStudents') + ': ' + profile.restriction.studentsLimit}}
                .game__label {{ $i18n.t('billing.billing_subscriptions_amountOfCourses') + ': ' + profile.restriction.courses}}
                .game__label {{ $i18n.t('progress.progress_preview_homeworkLimit') + ': ' + homeworkLimitValue }}
                .game__label {{ $i18n.t('progress.progress_preview_gameLimit') + ': ' + timeRestrictionValue }}
        .game-actions
            cs-button(
                v-if='!isSuperAdmin && showChangeTariffButton'
                color="blue"
                type="button"
                pattern="primary-outline"
                :disabled="user.type === 'teacher' || isTariffTrialActivated"
                @click="openTariffModal"
            )
                | {{ $i18n.t('common.common_course_changeTariff') }}
            cs-button(
                v-if='!isSuperAdmin && !showChangeTariffButton'
                color="green"
                type="button"
                :disabled="user.type === 'teacher' || isTariffTrialActivated"
                @click="openTariffModal"
            )
                | {{ $i18n.t('elements.elements_datePicker_updateTariff') }}
            cs-button(
                v-if='isSuperAdmin'
                color="blue"
                type="button"
                pattern="primary-outline"
                @click="goToEditPage"
            )
                | {{ $i18n.t('course.course_edit_button') }}

</template>

<script>
    import CsInput from '../../../elements/CsInput';
    import CsButton from '@/elements/CsButton.vue';
    import { mapState } from 'vuex';
    import ChangeTariffModal from '@/components/popups/ChangeTariffModal.vue';
    import SvgIcon from '@/elements/SvgIcon.vue';

    export default {
        props: {
            profile: Object,
        },
        data() {
            return {
                showSchools: false,
                showTariffModal: false,
                showTariffCoursesModal: false,
            };
        },
        methods: {
            openTariffModal() {
                this.showTariffModal = true;
            },
            closeTariffModal() {
                this.showTariffModal = false;
            },
            goToEditPage() {
                this.$router.push({ name: 'tariffs:edit', params: { id: this.profile.id } });
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            showChangeTariffButton() {
                return this.user.schools[0]?.tariffId !== this.profile.id;
            },
            isTariffTrialActivated () {
                return this.user.school.tariffTrial &&
                !this.user.school.tariffTrial?.isFinished;
            },
            isSuperAdmin() {
                return this.user.isSuperadmin;
            },
            homeworkLimitValue() {
                return this.profile.restriction.homeworkLimit
                    ? this.profile.restriction.homeworkLimit
                    : this.$i18n.t('progress.progress_preview_statusOf');
            },
            timeRestrictionValue() {
                return this.profile.restriction.timeRestriction
                    ? this.profile.restriction.timeRestriction + ' (сек)'
                    : this.$i18n.t('progress.progress_preview_statusOf');
            },
        },
        components: {
            SvgIcon,
            ChangeTariffModal,
            CsButton,
            CsInput,
        },
    };
</script>
<style lang="scss" scoped>
    .game-wrapper {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
        display: flex;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
    }
    .game-preview {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .game-title {
        font-size: 16px;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            font-size: 20px;
        }
    }

    .game__label {
        min-width: 0;
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 0.5rem;
        @include media($lg) {
            font-size: 16px;
        }
    }

    .game-input {
        flex-grow: 5;
        width: 65px;
        @include media($md) {
            margin-left: 15px;
        }
        @include media($lg) {
            width: 200px;
        }
    }

    .game-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 10px;
        margin-top: 10px;
    }
    .title-check {
        width: 25px;
        height: 25px;
        color: $hsl-color-green-58;
    }
    .green {
        color: $hsl-color-green-58;
    }
</style>
